var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('Header',{attrs:{"showHeaderSearch":this.isShowSearch(),"isShowBanner":false}}),_c('div',{staticClass:"main"},[_c('img',{attrs:{"src":require("@/assets/images/404_images/404.gif"),"alt":""}}),_c('p',[_vm._v("这里什么都没有")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.backToHome}},[_vm._v("返回首页")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }